import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Chip, Divider, Stack } from "@mui/material";
import { useSelector } from "react-redux";

function Sidebar({ menus }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { appointmentUnreadCount, messagesUnreadCount } = useSelector((state) => state.socketSlice);

  return (
    <Box
      sx={{
        width: "250px",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Stack divider={<Divider />}>
        {menus?.map((menu, i) => {
          const isAppointmentChat = menu?.name?.toLowerCase() === "appointment chat" || menu?.path?.includes("appointment-messages");
          const isGeneralMessages = menu?.name?.toLowerCase() === "messages" || (menu?.path?.includes("/messages") && !menu?.path?.includes("appointment-messages"));
          return (
            <Button
              sx={{
                py: 2,
                px: 2.5,
                lineHeight: 1,
                fontSize: "15px",
                fontWeight: "400",
                minHeight: "auto",
                flexDirection: "row",
                alignItems: "center",
                fontFamily: "Poppins",
                justifyContent: "start",
                textTransform: "capitalize",
                color: pathname === menu?.path ? "primary.main" : "other.color2",
                width: "100%",
              }}
              key={i}
              onClick={() => {
                navigate(
                  menu?.path,
                  { state: (menu?.path === "/member/profile/messages" || menu?.path === "/specialist/profile/messages" || menu?.path === "/member/profile/appointment-messages" || menu?.path === "/specialist/profile/appointment-messages") ? "test" : null }
                )
              }}
              startIcon={menu?.icon}
            >
              {menu?.name}
              {isAppointmentChat && appointmentUnreadCount > 0 && (
                <Chip
                  label={appointmentUnreadCount > 99 ? "99+" : appointmentUnreadCount}
                  size="small"
                  color="error"
                  sx={{
                    height: 20,
                    fontSize: "11px",
                    fontWeight: 600,
                    fontFamily: "Poppins",
                    px: 0.5,
                    ml: "auto",
                  }}
                />
              )}
              {isGeneralMessages && messagesUnreadCount > 0 && (
                <Chip
                  label={messagesUnreadCount > 99 ? "99+" : messagesUnreadCount}
                  size="small"
                  color="error"
                  sx={{
                    height: 20,
                    fontSize: "11px",
                    fontWeight: 600,
                    fontFamily: "Poppins",
                    px: 0.5,
                    ml: "auto",
                  }}
                />
              )}
            </Button>
          );
        })}
      </Stack> 
    </Box>
  );
}

export default Sidebar;
